<template>
  <div class="home">主页</div>
</template>

<script>
//默认跳转到主页
export default {
  
}
</script>

<style lang="scss" scoped>

</style>
